import { CognitoAuth } from 'amazon-cognito-auth-js'
import { CognitoUserPool } from 'amazon-cognito-identity-js'

// import { config as AWSConfig } from 'aws-sdk'

// AWSConfig.region = appConfig.region

// Creates a CognitoAuth instance
const createCognitoAuth = (appConfig) => {
  const appWebDomain = appConfig.userPoolBaseUri.replace('https://', '').replace('http://', '')
  const auth = new CognitoAuth({
    UserPoolId: appConfig.userPool,
    ClientId: appConfig.clientId,
    AppWebDomain: appWebDomain,
    TokenScopesArray: appConfig.tokenScopes,
    RedirectUriSignIn: appConfig.callbackUri,
    RedirectUriSignOut: appConfig.signoutUri
  })
  return auth
}

// Creates a CognitoUser instance
const createCognitoUser = (appConfig) => {
  const pool = createCognitoUserPool(appConfig)
  return pool.getCurrentUser()
}

// Creates a CognitoUserPool instance
const createCognitoUserPool = appConfig => new CognitoUserPool({
  UserPoolId: appConfig.userPool,
  ClientId: appConfig.clientId
  // Storage: new CookieStorage({secure: false, domain: "localhost"})
})

// Get the URI of the hosted sign in screen
const getCognitoSignInUri = (appConfig) => {
  const signinUri = `${appConfig.userPoolBaseUri}/login?response_type=code&client_id=${appConfig.clientId}&redirect_uri=${appConfig.callbackUri}`
  return signinUri
}

const getCognitoAuthorizeUri = (appConfig) => {
  return `${appConfig.userPoolBaseUri}/oauth2/authorize?response_type=code&client_id=${appConfig.clientId}&redirect_uri=${appConfig.callbackUri}`
}

// Parse the response from a Cognito callback URI (assumed a token or code is in the supplied href). Returns a promise.
const parseCognitoWebResponse = (appConfig, href: string) => {
  return new Promise((resolve, reject) => {
    const auth = createCognitoAuth(appConfig)

    // userHandler will trigger the promise
    auth.userhandler = {
      onSuccess: function (result: any) {
        resolve(result)
      },
      onFailure: function (err: any) {
        reject(new Error('Failure parsing Cognito web response: ' + err))
      }
    }
    auth.parseCognitoWebResponse(href)
  })
}

// Gets a new Cognito session. Returns a promise.
const getCognitoSession = (appConfig) => {
  return new Promise((resolve, reject) => {
    const cognitoUser = createCognitoUser(appConfig);
    
    
    if(cognitoUser !== null) {
      cognitoUser.getSession((err: any, result: any) => {
        if (err || !result) {
          console.log(err)
          reject(new Error('Failure getting Cognito session: ' + err))
          signOutCognitoSession(appConfig);
          return
        }

        cognitoUser.getUserData((error, result) => {
            if(error || !result) {
              console.log(error);
              signOutCognitoSession(appConfig);
              return
            }
            cognitoUser.getSession((sessionErr: any, sessionResponse: any) => {
              if (sessionErr) {
                console.log(sessionErr);
                return;
              }
            // Resolve the promise with the session credentials
            console.debug('Successfully got session: ' + JSON.stringify(sessionResponse));
            const session = {
              credentials: {
                accessToken: sessionResponse.accessToken.jwtToken,
                idToken: sessionResponse.idToken.jwtToken,
                refreshToken: sessionResponse.refreshToken.token
              },
              user: {
                userName: sessionResponse.idToken.payload['cognito:username'],
                email: sessionResponse.idToken.payload.email,
                ...sessionResponse.idToken.payload
              }
            }
            resolve(session)
          });
        }, {bypassCache: true});
      })

    } else {
      signOutCognitoSession(appConfig);
      reject('no user')
    }
  })
}

// Sign out of the current session (will redirect to signout URI)
const signOutCognitoSession = (appConfig) => {

  const user = createCognitoUser(appConfig)
  user?.getSession(() => {
    user?.globalSignOut({
      onSuccess: () => {
        const auth = createCognitoAuth(appConfig)
        auth.signOut()
      },
  
      onFailure: (err) => {
        console.error(err);
        const auth = createCognitoAuth(appConfig)
        auth.signOut()
      }
    });
  })

}

export default {
  createCognitoAuth,
  createCognitoUser,
  createCognitoUserPool,
  getCognitoSession,
  getCognitoSignInUri,
  parseCognitoWebResponse,
  signOutCognitoSession,
  getCognitoAuthorizeUri
}
